import fastApi from "@/services/http/fastApiClient";

/** 도메인 전용 서비스 (Upload & Status Poll)
 * C:\VUE3\platform\src\services\modelService.js
 */
export const modelService = {
  /**
   * @param {FormData} formData
   *  * @param {{signal?:AbortSignal}} [options]
   * @returns {Promise<{ id: string }>}
   */


async upload(formData, options = {}) {
    // flask.post(...) 은 interceptor 이후 response.data(envelope)를 바로 반환
   const envelope = await fastApi.post("/fastapi/upload/model", formData, { signal: options.signal });
  
    // envelope.id 에 실제 ID가 들어 있으므로 이걸 꺼내서 반환
    const { id } = envelope;
    if (!id) {
      console.warn("[fastApi] upload: 응답에 id가 없습니다.", envelope);
      throw new Error("upload response did not contain an id");
    }
    return { id };
  },

  /**
   * @param {string} id
   *  * @param {{signal?:AbortSignal}} [options]
   * @returns {Promise<ConversionResult>}   (domain object)
   */
 
  
  async getStatus(id, options = {}) {
    // interceptor를 통과한 response.data(envelope)가 곧 리턴됩니다.
    const envelope = await fastApi.get(`/fastapi/result/${id}`, { signal: options.signal });
  
    if (!envelope || typeof envelope.status === 'undefined') {
      console.warn(`[fastApi] getStatus: 잘못된 응답`, envelope);
      throw new Error('getStatus 응답이 올바르지 않습니다.');
    }
    return envelope;
  },

};
